import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, STATUS } from "../../../Constants";
import axios from "axios";

// For Get Comments More Posts
const getAllcommentsEndPoint = (args)=>`${DomainName}/page/comments?userAccessToken=${args.userToken}&postId=${args.postId}` ; 

export const getAllCollectedCommentsAPI = createAsyncThunk('collect/comments' , async (args , thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.get(getAllcommentsEndPoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data.comments
    }catch(error){
        return rejectWithValue(error)
    }
})

// For Default State
const initialState = {
posts : [] , 
savedId : [] , 
comments : [] , 
statusComments : STATUS.IDLE
}

const CollectSlice = createSlice({
    name : "collect" , 
    initialState ,
    reducers : {
        restPosts : (state )=>{
            state.posts = [] ; 
            state.comments = [] ; 
            state.savedId = [] ; 
        } ,
        addPost : (state , action)=>{
            if(!state.posts.includes(action.payload.data)){
                state.posts.push(action.payload.data);
            }
            
        } , 
        removePost : (state , action)=>{
            state.posts = state.posts.filter((item)=>item.id !== action.payload.data.id)
        },
        selectAll : (state ,action)=>{
            if(state.savedId.length === 0) {
                state.savedId = action.payload
            }else{
                action.payload.map((item)=>{state.savedId.push(item)});
            }
        } , 
        selectAllPostDetails : (state , action)=>{
            if(state.savedId.length === 0) {
                state.posts = action.payload
            }else{
                action.payload.map((item)=>state.posts.push(item)) ;
            }
        } ,
        addPostId : (state , action)=>{
            if(!state.savedId.includes(action.payload))
                state.savedId.push(action.payload) ; 
        }

    } , extraReducers :(builder)=>{
        builder
        // For Get All Collected Comments
        .addCase(getAllCollectedCommentsAPI.fulfilled , (state , action)=>{
            state.comments= action.payload ; 
            state.statusComments = STATUS.SUCCESS ; 
        }) 
        .addCase(getAllCollectedCommentsAPI.pending , (state , action)=>{
            state.statusComments = STATUS.LOADDING ; 
        })
        .addCase(getAllCollectedCommentsAPI.rejected , (state , action)=>{
            state.statusComments = STATUS.ERROR
        })
    }
})

export default CollectSlice.reducer


export const {restPosts,addPostId ,addPost , selectAll ,removePost ,selectAllPostDetails} = CollectSlice.actions ; 

export const getSavedPosts = state => state.CollectSlice.posts;
export const getSavedPostsIds = state => state.CollectSlice.savedId;
export const getSavedComments = state => state.CollectSlice;
